exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "i.icon-small[data-v-d9f38a70] {\n  font-size: 12px;\n}\n.icon-large[data-v-d9f38a70] {\n  font-size: 2em;\n}\n", ""]);

// exports
